<template>
  <v-snackbar
    v-model="displayError"
    color="appRed"
    :multi-line="true"
    :right="true"
    :timeout="6000"
    :top="true"
    :vertical="false"
  >
    <span class="body-1">{{ error }}</span>
    <v-btn
      small
      fab
      icon
      @click.prevent.stop="toggleError(false)"
    >
      <v-icon>close</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script lang="ts">
import { mapState } from 'vuex'
import { Component, Prop, Vue, Mixins, Watch } from 'vue-property-decorator'
import { State } from 'vuex-class'

@Component
export default class ErrorToast extends Vue {
  @State(state => state.status.error) error: any

  get displayError (): boolean {
    return this.$store.state.status.displayError
  }

  set displayError (value) {
    this.toggleError(value)
  }

  private toggleError (value: boolean) {
    this.$store.dispatch('displayError', value)
  }
}
</script>
